module.exports = __webpack_public_path__ + "img/flower-01.6254e3b1.png";